import React from 'react';
import ReactSelect from 'react-select';

const Select = (props) => <ReactSelect {...props} />;

export default Select;
